import React from "react";
import { useField } from "formik";

const styles = {
  control: {
    marginTop: "10px",
    marginBottom: "10px",
  },
  label: {
    color: "#222",
    display: "block",
  },
  input: {
    width: "100%",
    height: "40px",
    border: "1px solid #DDD",
    borderRadius: "5px",
  },
  error: {
    color: "#C00",
  },
};

export default function Select({ label, ...props }) {
  const [field, meta] = useField(props);
  return (
    <div style={styles.control}>
      <label style={styles.label}>{label}</label>
      <select style={styles.input} {...field} {...props} />
      {meta.touched && meta.error ? (
        <div style={styles.error}>{meta.error}</div>
      ) : null}
    </div>
  );
}
